module.exports = __webpack_public_path__ + "static/img/questionnaire-02.ca9ab35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/questionnaire-02.png
// module id = cec9
// module chunks = 1